<template>
  <v-row>
    <v-card max-width="100%" width="100%">
      <v-toolbar color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('stats.cost')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "line" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-col v-if="!chart" cols="12" align="center" style="height: 400px">
          <v-progress-circular
          style="margin-top: 150px"
            :size="100"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>
        <div id="chart"></div>
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "Resume",
  data() {
    return {
      type: "bar",
      chart: null
    };
  },
  mounted() {
    setTimeout(() => this.render(), 0)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    init() {
      this.render();
    },
    render() {
      let categories = this.categories();
      let series = this.series();
      if (this.chart) {
        this.chart.updateOptions(
          {
            series: series,
            xaxis: {
              categories: categories
            },
            chart: {
              type: this.type
            }
          },
          true
        );
      } else {
        this.chart = new ApexCharts(document.querySelector("#chart"), {
          series: series,
          xaxis: {
            categories: categories
          },
          chart: {
            type: this.type,
            height: 400
          }
        });
        this.chart.render();
      }
    },
    categories() {
      let categories = [];
      for (let index = 0; index < this.week; index++) {
        categories.push(this.$t("general.smallWeek") + (index + 1));
      }
      return categories;
    },
    series() {
      let series = [];
      this.$store.getters["game/assignableCompanies"].forEach(company => {
        let tempData = [];
        for (let index = 0; index < this.week; index++) {
          let stock = company.data.cost.stock[index] ? company.data.cost.stock[index] : 0
          let remains = company.data.cost.remains[index] ? company.data.cost.remains[index] : 0
          tempData.push(stock + remains)
        }
        series.push({
          name: company.name,
          data: tempData
        });
      });
      return series;
    },
    async changeType() {
      await this.chart.destroy();
      this.chart = null;
      if (this.type == "line") {
        this.type = "bar";
      } else {
        this.type = "line";
      }
      this.render();
    }
  },
  computed: {
    week() {
      let max = 0;
      this.$store.getters["game/assignableCompanies"].forEach(company => {
        if (company.data.cost.stock.length > max) {
          max = company.data.cost.stock.length;
        }
        if (company.data.cost.remains.length > max) {
          max = company.data.cost.remains.length;
        }
      });
      return max;
    }
  }
};
</script>
